import { render } from "./MyBooks.vue?vue&type=template&id=5e8d6583"
import script from "./MyBooks.vue?vue&type=script&lang=js"
export * from "./MyBooks.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__